import React from "react";
import { Row, Col, Typography, Alert } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

interface SuccessMessageProps {
  platfrom: string;
  brand: string;
  totalOrder: number;
  orderNoLength: number;
  image: string;
  timeUsed: string;
  uploadTime: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  platfrom,
  brand,
  totalOrder,
  orderNoLength,
  image,
  timeUsed,
  uploadTime,
}) => {
  return (
    <div style={{ textAlign: "center", padding: "0px 20px 20px 20px" }}>
      {/* <CheckCircleOutlined style={{ fontSize: '50px', color: '#52c41a' }} /> */}
      <Row justify="center" align="middle" style={{ marginBottom: "20px" }}>
        <Col>
          <CheckCircleFilled
            style={{ fontSize: "30px", color: "#52c41a", marginRight: "8px", marginTop: "16px" }}
          />
        </Col>
        <Col>
          <Typography.Title level={2} type="success">
            Order ครบถ้วน
          </Typography.Title>
        </Col>
      </Row>
      <div style={{ transform: "scale(2.5)", display: "inline-block" }}>
        <img
          src={image}
          alt="Success"
          style={{ width: "150px", marginTop: "20px", marginBottom: "20px" }}
        />
      </div>

      <Row justify="center" align="middle" style={{ marginTop: "40px" }}>
        <Col span={12}>
          <Typography.Text strong style={{ fontSize: "22px", color: "#656565" }}>
            Platform: {platfrom}
          </Typography.Text>
        </Col>
        <Col span={12}>
          <Typography.Text strong style={{ fontSize: "22px", color: "#656565" }}>
            Brand: {brand}
          </Typography.Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify="center" style={{ marginTop: "30px" }}>
        <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
          <div style={highlightBoxStyle("#ffa500")}>
            <Typography.Text strong style={highlightTextStyle}>
              จำนวนที่ขาด: {orderNoLength}
            </Typography.Text>
          </div>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
          <div style={highlightBoxStyle("#007bff")}>
            <Typography.Text strong style={highlightTextStyle}>
              จำนวนทั้งหมด: {totalOrder}
            </Typography.Text>
          </div>
        </Col>
      </Row>
      <Alert
        message="ตรวจสอบครบถ้วน"
        description={
          <>
            <Col>
              <Typography.Text strong style={{ color: "green" }}>
                เวลาที่ใช้โดยประมาณ : {timeUsed}{" "}
              </Typography.Text>{" "}
              ออร์เดอทั้งหมดได้รับการตรวจสอบแล้ว ไม่มีออร์เดอที่ต้องตรวจสอบใหม่.
            </Col>
            <Col style={{ marginTop: "10px" }}>
              <Typography.Text strong style={{ color: "black" }}>
                * Uploaded at: {uploadTime}
              </Typography.Text>
            </Col>
          </>
        }
        type="success"
        showIcon
        style={{ textAlign: "left", marginTop: "20px" }}
      />
    </div>
  );
};

const highlightBoxStyle = (backgroundColor: string): React.CSSProperties => ({
  backgroundColor,
  padding: "10px",
  borderRadius: "8px",
  textAlign: "center",
  width: "100%",
  maxWidth: "200px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
});

const highlightTextStyle: React.CSSProperties = {
  fontSize: "18px",
  color: "#fff",
};

export default SuccessMessage;
